import React, { useState, useEffect } from 'react';
import {Table, TableHead, TableBody, TableRow, TableCell} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { joinByKeys } from "../../Js/Common";

const ClasswiseLearnerAttempatedAssignments = (props) => {
    //Hooks
    const styles = useStyles();
    const { classWiseLearnersData } = props;
    return (
        <>
            <Table sx={{ minWidth: 400 }} >
                <TableHead>
                    <TableRow>
                        <TableCell align="justify" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '700', padding: '1px', py: 1.5, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Learner Name
                        </TableCell>
                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '700', padding: '1px', py: 1.5, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Attempted <br /> Assignments
                        </TableCell>
                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '700', padding: '1px', py: 1.5, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Total <br /> Assignments
                        </TableCell>
                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '700', padding: '1px', py: 1.5, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>                            
                            Unattempted <br /> Assignments
                        </TableCell>
                    </TableRow>
                </TableHead>
            </Table>
            <div style={{ height: '65vh', overflow: 'auto' }} className={styles.scrollBar}>
                {classWiseLearnersData && classWiseLearnersData.data && (
                    <Table style={{ tableLayout: 'fixed' }}>
                        <TableBody>
                            {classWiseLearnersData.data.map((learnerData, learnerIndex) => {
                                return (
                                    <TableRow key={`learnerUsage_${learnerIndex}`} sx={{ py: 0, cursor: "pointer" }} onClick={() => { props.handleNavigate(learnerData) }}>
                                        <TableCell align="left" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '600', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                            {joinByKeys(learnerData.name, ['firstname', 'lastname'], ' ')}
                                        </TableCell>
                                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                            {learnerData.total_attempted_assignment || 0}
                                        </TableCell>
                                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                            {learnerData.total_assignments || 0}
                                        </TableCell>
                                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                            {learnerData.total_not_attempted_assignment || 0}
                                        </TableCell>

                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                )}
            </div>
        </>
    );
}
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
})
export default ClasswiseLearnerAttempatedAssignments;